<template>
    <q-page>
        <div class="q-display-2">Materiały wideo</div>

        <div>
            <upload @uploaded="uploaded" inline/>
        </div>

        <div class="virtualCollectionWrapper" ref="virtualCollectionWrapper">
            <virtual-collection
                :collection="items"
                :height="virtualHeight"
                :width="virtualWidth"
                :cellSizeAndPositionGetter="cellSizeAndPositionGetter"
            >
                    <video-viewer
                        slot="cell"
                        slot-scope="props"
                        class="video"
                        :model="props.data"
                        :deletable="true"
                        @opened="handleOpen"
                        />
            </virtual-collection>
        </div>
    </q-page>
</template>

<script>
    import FileUpload from './FileUpload.vue'
    import VideoViewer from './pole/viewers/VideoViewer'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import Upload from './Upload'

    export default {
        name: 'Movies',
        mounted () {
            this.fetch()
            this.updateContainerDimensions();

            window.addEventListener('resize', this.updateContainerDimensions, 'false');
            if (window.ResizeObserver) {
                this.ro = new ResizeObserver(this.updateContainerDimensions)
                .observe(this.$refs.virtualCollectionWrapper);
            }

            this.items = this.$store.getters.video.map(v => ({
                data: {
                    ...v,
                    opened: false
                }
            }));
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.updateContainerDimensions);
            if (this.ro) {
                this.ro.unobserve(this.$refs.virtualCollectionWrapper);
                this.ro.disconnect();
            }
        },
        methods: {
            handleOpen (index) {
                this.items.find(({data: {id}}) => id === index).data.opened = true
            },
            fetch () {
                this.loading = true

                this.$store.dispatch('fetchAll', {
                    what: 'file',
                })
            },
            uploaded () {

            },
            updateContainerDimensions () {
                if (this.$refs.virtualCollectionWrapper) {
                    const maxW = this.$refs.virtualCollectionWrapper.clientWidth
                    const maxH = window.innerHeight - this.$refs.virtualCollectionWrapper.getBoundingClientRect().top
                    this.virtualWidth = maxW
                    this.virtualHeight = maxH
                }
            },
            cellSizeAndPositionGetter (item, index) {
                const maxCol = Math.floor(this.virtualWidth / 230)
                const totalSpace = this.virtualWidth - 230 * maxCol

                return {
                    width: 20,
                    height: 150,
                    x: (index % maxCol) * (230 + totalSpace / maxCol),
                    y: parseInt(index / maxCol) * 150,
                }
            },

        },
        components: {
            Upload,
            QCardMain,
            QCard,
            QCardMedia,
            VideoViewer,
            FileUpload,
        },
        computed: {
            originalItems () {
                return this.$store.getters.video
            },
        },
        watch: {
            originalItems (current) {
                this.items = current.map(v => ({
                    data: {
                        ...v,
                        opened: false
                    }
                }));

            }
        },
        data () {
            return {
                loading: false,
                virtualWidth: 0,
                virtualHeight: 0,
                ro: undefined,
                items: []
            }
        },
    }
</script>

<style lang="scss" scoped>
    .video {
        width: 250px;

        video {
            width: 250px;
        }
    }

    .virtualCollectionWrapper {
        width: 100%;
        height: 100%;

        .vue-virtual-collection {
            scroll: auto;
        }
    }
</style>